import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   *
   * @param {
   *   bank: 은행코드,
   *   accountNumber: 계좌번호
   * } query
   * @returns
   */
  getFundaPaygateAccountHoldername(query) {
    return defaultClient.get(`/funda-pay-gate/account-holder-name/?${qs.stringify(query)}`)
  },
}
